import linksTpl from '../templates/admin/links.directive.html';

function AdminLinksController(CurrentUserService, $location) {
  var vm = this;
  vm.exampleEditUrl = editLink('examples');
  vm.partnerEditUrl = editLink('partners');

  function fetchPermissions() {
    return CurrentUserService.get().then(user => {
        vm.userSignedIn = !!user;
      if (vm.userSignedIn) {
        vm.user = user;
        vm.userIsAdmin = user.admin;
        vm.userIsSuperUser = user.superUser;
      }
    });
  }

  function editLink(resource) {
    var subdomain = $location.search()['subdomain'];
    if (subdomain) {
      return resource + '/edit?subdomain=' + subdomain;
    } else {
      return resource + '/edit';
    }
  }

  fetchPermissions();

  return vm;
}

AdminLinksController.$inject = ['CurrentUserService', '$location'];

export default function strAdminLinks() {
  return {
    restrict: 'E',
    template: linksTpl,
    controller: AdminLinksController,
    controllerAs: 'linksCtrl',
    replace: true
  };
}
